export const environment = {
    production: true,
    sentryEnabled: true,
    websocketEnabled: false,
    mandant: '',
    geraeteNummer: '',
    host: 'https://app.recomobil.de',
    logLevel: 10 // DEBUG (das ist das Log-Level bei Start. Wird dann nach Laden der Konfiguration hoch gedreht)
};
